export const BUFFER = 200;

export const MOBILE_GROUP_TAB_SELECTOR_HEIGHT = 60;